import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../store/store';

export interface LoadingState {
    isLoading: boolean;
    timer?: number;
    isSkeleton?: boolean;
    isMini?: boolean;
    text?: string;
}

interface UIState {
    loading?: LoadingState;
    modal?: any;
}

const initialState: UIState = {};

const uiStateSlice = createSlice({
    name: 'uiState',
    initialState,
    reducers: {
        setUILoading: (state, action: PayloadAction<LoadingState>) => {
            const { timer, isSkeleton, isMini, text } = action.payload;

            if (typeof isMini !== 'undefined') {
                state.loading = {
                    isLoading: false,
                    isMini,
                };
            } else if (typeof isSkeleton !== 'undefined') {
                state.loading = {
                    isLoading: false,
                    isSkeleton,
                };
            } else {
                state.loading = {
                    isLoading: true,
                    timer: timer ? Number(timer) : undefined,
                    isSkeleton: undefined,
                    isMini: undefined,
                    text,
                };
            }
        },
        resetUILoading: (state) => {
            const { isLoading, timer, isSkeleton, isMini } = state.loading || {};

            if (!isLoading && !timer && !isSkeleton && !isMini) {
                return;
            }

            state.loading = {
                isLoading: false,
                timer: undefined,
                isSkeleton: false,
                isMini: false,
                text: undefined,
            };
        },
        setUIModal: (state, action: PayloadAction<any>) => {
            state.modal = action.payload;
        },
    },
});

export const selectUILoading = (state: RootState) => state.ui.loading;
export const selectUIIsSkeleton = (state: RootState) => state.ui.loading?.isSkeleton;
export const selectUIIsMiniLoading = (state: RootState) => state.ui.loading?.isMini;

export const { setUILoading, resetUILoading, setUIModal } = uiStateSlice.actions;
export default uiStateSlice.reducer;
